// extracted by mini-css-extract-plugin
module.exports = {"samplesContainer":"ManageSamples_samplesContainer_1Ujuv","marginRight8px":"ManageSamples_marginRight8px_2_GKV"};